import JSEncrypt from "jsencrypt";
import userModel from "./../models/user.js";
import moment from "moment-timezone";
import Storage from "../utils/storage.js";
import qs from "qs";
/* ---------- 常用方法 ---------- */
const Base = {
  /*
   *@description: 时区
   *@author: 薛微微
   *@date: 2023-06-21 16:45:18
   */
  timeZone() {
    var timeZone = moment.tz.guess();
    if (timeZone == "" || undefined) {
      timeZone = "Asia/Taipei";
    }
    return timeZone;
  },
  sdkVer() {
    var sdkVer = "1.0.0";
    return sdkVer;
  },
  sysLanguage() {
    var sysLanguage = "zh";
    return sysLanguage;
  },
  getVersion() {
    var version = "1.0";
    return version;
  },
  // 随机字符串（12位字符，数字+小写字母）
  nonce(len) {
    var $chars = "abcdefghijklmnopqrstuvwxyz1234567890";
    var maxPos = $chars.length;
    var pwd = "";
    for (var i = 0; i < len; i++) {
      pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  },
  // 解析URL參數
  parseUrl(link) {
    return qs.parse(link.split("?")[1]);
  },
  // 获得系统版本
  getSystem() {
    let system = "PC";
    if (/(iPhone|iPad|iPod|iOS)/i.test(window.navigator.userAgent)) {
      system = "IOS";
    } else if (/(Android)/i.test(window.navigator.userAgent)) {
      system = "Android";
    }
    return system;
  },
  message(text, type) {
    let closeText = "";
    if (type == "back") closeText = "返回";
    else if (type == "close") closeText = "关闭";
    const div = document.createElement("div");
    div.className = "message-mask";
    div.innerHTML =
      "<div class='message'><div class='m-body'><p class='b-text'>" +
      text +
      "</p></div><div class='m-footer'><p id='close' class='f-text'>" +
      closeText +
      "<p></div></div>";
    document.body.appendChild(div);
    const close = document.getElementById("close");
    close.onclick = function () {
      if (type == "back") {
        window.history.back();
      } else if (type == "close") {
        document.body.removeChild(div);
      }
    };
  },
  toast: async (text) => {
    const div = document.createElement("div");
    div.id = "toast";
    div.className = "toast";
    div.innerHTML = text;
    if (!document.getElementById("toast")) document.body.appendChild(div);
    await new Promise((resolve) => {
      setTimeout(() => {
        div.className = "toast active";
        resolve();
      }, 300);
    });
    await new Promise((resolve) => {
      setTimeout(() => {
        div.className = "toast";
        resolve();
      }, 3000);
    });
    await new Promise((resolve) => {
      setTimeout(() => {
        document.body.removeChild(div);
        resolve();
      }, 300);
    });
  },
  encrypt: (data) => {
    let jse = new JSEncrypt();
    let key = Storage.localStorageGet("publicKey");
    let publicKey = `-----BEGIN PUBLIC KEY-----
  ${key}
  -----END PUBLIC KEY-----`;
    if (typeof data == "object") {
      data = JSON.stringify(data);
    }
    jse.setPublicKey(publicKey);
    const encryptKey = jse.encrypt(data);
    return encryptKey;
  },
  // 获取token
  getToken: async () => {
    let urlData = Storage.localStorageGet("urlData");
    let data = {
      cch_id: urlData.cch_id,
      app_id: urlData.app_id,
    };
    let suc = await userModel.getToken(data);
    if (suc.code == 200) {
      Storage.localStorageSet("token", suc.data.token);
      Storage.localStorageSet("publicKey", suc.data.pub_key);
    }
  },
  //判断是否是微信浏览器的函数
  isWeiXin() {
    //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    var ua = window.navigator.userAgent.toLowerCase();
    //通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
    } else {
      return false;
    }
  },
  mType() {
    var mType = "";
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      mType = "IOS";
    } else if (/(Android)/i.test(navigator.userAgent)) {
      mType = "AND";
    } else {
      mType = "PC";
    }
    return mType;
  },
  // 判断是否ios内购
  isIosPay() {
    if (navigator.userAgent.indexOf("iosh5") > -1) {
      return true;
    } else {
      return false;
    }
  },
  // 判断是否安卓H5
  isAndroidH5() {
    if (navigator.userAgent.indexOf("RastarH5Client") > -1) {
      return true;
    } else {
      return false;
    }
  },
  checkSysteam() {
    var mType = "";
    if (
      /(iPhone|iPad|iPod|iOS|Android|SymbianOS|Windows Phone|Mobile)/i.test(
        navigator.userAgent,
      )
    ) {
      mType = "MOBILE";
    } else {
      mType = "PC";
    }
    return mType;
  },
  // 时间戳毫秒+随机数
  timeSigin() {
    var num = ""; //定义用户编号
    for (
      var i = 0;
      i < 4;
      i++ //4位随机数，用以加在时间戳后面。
    ) {
      num += Math.floor(Math.random() * 10);
    }
    num = new Date().getTime() + num;
    return num;
  },
  // ua+时间戳毫秒+随机数
  timeSiginUa() {
    var num = ""; //定义用户编号
    for (
      var i = 0;
      i < 4;
      i++ //4位随机数，用以加在时间戳后面。
    ) {
      num += Math.floor(Math.random() * 10);
    }
    num = navigator.userAgent + new Date().getTime() + num;
    return num;
  },
  // 根據語言添加指定class作為唯一標識展示對應語言的圖片
  langPicClass() {
    var langClass = navigator.language || navigator.userLanguage;
    if (langClass.substring(0, 2) == "zh") {
      langClass = "zh";
    } else if (langClass.includes("es")) {
      langClass = "es";
    } else {
      langClass = "en";
    }
    return langClass;
  },
};
export default Base;
